(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/side-nav/assets/javascripts/lazy-statistic.js') >= 0) return;  svs.modules.push('/components/tipsen/side-nav/assets/javascripts/lazy-statistic.js');
"use strict";

const tipsenLazy = svs.components.tipsen.tipsenLazy.tipsenLazy;
const LazyStatistic = tipsenLazy('/cl/tipsen/route-statistic', () => svs.components.tipsen.routeStatistic.RouteStatistic);
setGlobal('svs.components.tipsen.sideNav.LazyStatistic', LazyStatistic);

 })(window);